import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { ActionButtons } from './ActionButtons';
import { useList } from './ListContext';
import { StatusIndicator } from '../StatusIndicator';
export var RenderList = function (_a) {
    var renderItem = _a.renderItem, titleField = _a.titleField, keyField = _a.keyField, actionButtons = _a.actionButtons, getStatus = _a.getStatus;
    var _b = useList(), items = _b.items, isLoading = _b.isLoading;
    var effectiveKeyField = keyField !== null && keyField !== void 0 ? keyField : 'id';
    if (isLoading) {
        return (_jsx(Paper, { elevation: 2, sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
            }, children: _jsx(CircularProgress, {}) }));
    }
    if (items.length === 0) {
        return (_jsxs(Paper, { elevation: 3, sx: { p: 5, textAlign: 'center' }, children: [_jsx(InfoOutlinedIcon, { fontSize: "large", color: "primary" }), _jsx(Typography, { variant: "subtitle1", children: "Nenhum resultado encontrado." })] }));
    }
    return (_jsx(Stack, { spacing: 2, children: items.map(function (item) {
            var key = item[effectiveKeyField];
            var title = undefined;
            if (typeof titleField === 'function') {
                title = titleField(item);
            }
            else if (titleField) {
                title = item[titleField];
            }
            var statusData = getStatus ? getStatus(item) : null;
            if (!key) {
                throw new Error("Key field \"".concat(String(keyField), "\" is missing in one or more items."));
            }
            return (_jsxs(Paper, { elevation: 3, sx: { padding: 0, pb: 0 }, children: [_jsxs(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            p: '0.875rem',
                            pb: 1,
                        }, children: [_jsxs(Box, { flexGrow: 1, children: [!!title && (_jsx(Typography, { variant: "subtitle1", children: "".concat(title) })), renderItem(item)] }), actionButtons && (_jsx(Box, { sx: { whiteSpace: 'nowrap' }, children: _jsx(ActionButtons, { item: item, actions: actionButtons }) }))] }), statusData && (_jsx(StatusIndicator, { status: statusData.status, message: statusData.message }))] }, key));
        }) }));
};
